import React, { useEffect, useState } from 'react';
import api from '~/services/api';
import { Label, Input, Select, TextArea } from '~/componentes/CustomForm';

import { Container } from './styles';
import CustomScrollBar from '~/componentes/CustomScrollBar';
import { Materialize } from '~/styles/materializeGrid';
import { SLModalFooter } from '~/pages/Sistema/componentes/SistemaList';
import ShowConfirmacao from '~/utils/ShowConfirmacao';

function CreateEditContent({ mountedData }) {
  const [clientes, setClientes] = useState([]);
  const [cliente, setCliente] = useState({});
  const [ativo, setAtivo] = useState(
    !mountedData ? "true" : mountedData?.ativo ? "true" : "false",
  );

  useEffect(() => {
    api.get("/signed/empresa/gestorprojeto/cliente/clientes", { params: { ativo: 1 } }).then((r) => setClientes(r?.data));
  
  }, []);
  async function handleSubmit(data, options) {
    const { closeReload } = options || {};

    return ShowConfirmacao(
      async () => {
        let thisData = {
          ...data,
          ...(mountedData?.id ? { id: mountedData?.id } : {}),
          ativo: ativo === 'true' ? true : false,
        };
        let response;
        if (mountedData?.id)
          response = await api.put(
            '/signed/empresa/gestorprojeto/gerencia/clientesolicitante',
            thisData,
          );
        else
          response = await api.post(
            '/signed/empresa/gestorprojeto/gerencia/clientesolicitante',
            thisData,
          );

        if (response?.status === 200) {
          closeReload && closeReload();
        }
        return response;
      },
      {
        errorModal: {
          defaultMessage: `Ocorreu um erro ao ${
            mountedData?.id ? 'atualizar' : 'cadastrar'
          } esse Cliente Solicitante, por favor, tente novamente mais tarde.`,
        },
        message: `Tem certeza que deseja ${
          mountedData?.id ? 'atualizar' : 'cadastrar'
        } esse Cliente Solicitante?`,
        successModal: `Cliente Solicitante ${
          mountedData?.id ? 'atualizado' : 'cadastrado'
        } com sucesso!`,
      },
    );
  }

  return (
    <Container onSubmit={handleSubmit} defaultScroll={true}>
      <Materialize className="materialize">
        <div className="row header">
          <p className="h-descricao">
            Preencha as informações corretamente, e se atente ao (*) pois são
            campos obrigatórios
          </p>
        </div>
        <div className="row">
          <Label title="Cliente *" className="col s4 m4 l4">
            <Select
              required="true"
              isString
              list={{ list: clientes, value: 'id', label: 'nomeFantasia' }}
              name="idCliente"
              firstOption
              defaultValue={mountedData?.idCliente}
              onChange={e => {
                const v = e.currentTarget.value || 'true';
                const cliente = clientes?.find(e => e?.id == parseInt(v));
                setCliente(cliente || {});
              }}
            />
          </Label>
          <Label title="Nome *" className="col s4 m4 l4">
            <Input name="nome" defaultValue={mountedData?.nome} />
          </Label>
          <Label title="Email *" className="col s3 m3 l3">
            <Input name="email" defaultValue={mountedData?.email} />
          </Label>
          <Label title="Telefone *" className="col s3 m3 l3">
            <Input name="telefone" defaultValue={mountedData?.telefone} />
          </Label>
          <Label title="Area" className="col s14 m14 l4">
            <Input name="area" defaultValue={mountedData?.area} />
          </Label>
          <Label title="Ativo *" className="col s2 m2 l2">
            <Select
              isString
              list={{
                list: [
                  { id: 'true', titulo: 'Sim' },
                  { id: 'false', titulo: 'Não' },
                ],
                value: 'id',
                label: 'titulo',
              }}
              name="ativo"
              defaultValue={mountedData?.ativo?.toString()}
              onChange={e => {
                const v = e.currentTarget.value || 'true';
                setAtivo(v);
              }}
            />
          </Label>
        </div>
      </Materialize>
    </Container>
  );
}

export default CreateEditContent;
